/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CustomPercentile } from '../models/CustomPercentile';
import type { CustomPercentileRequest } from '../models/CustomPercentileRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CustomPercentileService {

    /**
     * Get list of custom percentiles
     * @returns CustomPercentile Success
     * @throws ApiError
     */
    public static listCustomPercentile(): CancelablePromise<Array<CustomPercentile>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/customPercentile',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Add Custom Percentiles For a Company
     * @returns CustomPercentile Success
     * @throws ApiError
     */
    public static createCustomPercentile({
        requestBody,
    }: {
        requestBody: CustomPercentileRequest,
    }): CancelablePromise<CustomPercentile> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/customPercentile',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update Custom Percentiles
     * @returns CustomPercentileRequest Success
     * @throws ApiError
     */
    public static updateCustomPercentile({
        id,
        requestBody,
    }: {
        /**
         * Custom Percentile ID
         */
        id: number,
        requestBody: CustomPercentile,
    }): CancelablePromise<CustomPercentileRequest> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/customPercentile/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete Custom Percentiles
     * @returns any Success
     * @throws ApiError
     */
    public static remove({
        id,
    }: {
        /**
         * Custom Percentile ID
         */
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/customPercentile/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
